
	import { Component, Vue } from 'vue-property-decorator';
	import aps from '@/HostApp/store/ApsModules/ApsModule';
	import ViewportWrapper from '@/HostApp/ui/system/ViewportWrapper.vue';

	const CURRENT = 1;
	const CURRENT_AND_MODAL = 2;

	@Component({
		components: { ViewportWrapper }
	})
	export default class TheBreadcrumbs extends Vue {
		protected get navigationContext(): Array<APS.INavigationTreeContext> {
			return aps.navigation.tree?.context || [];
		}

		protected get navigationItems(): Array<APS.INavigationTreeContext> {
			return this.navigationContext.filter((item) => item.viewLabel);
		}

		protected get breadcrumbs(): Array<string> {
			return this.navigationItems.map((item) => item.viewLabel);
		}

		protected get breadcrumbsWithoutCurrent(): Array<string> {
			const sliceCount = this.breadcrumbs.length - (aps.context._view.popup ? CURRENT_AND_MODAL : CURRENT);

			return this.breadcrumbs.slice(0, sliceCount > CURRENT ? sliceCount : CURRENT);
		}

		protected get hasEmptyLabel(): boolean {
			const { length } = this.navigationContext;

			return !this.navigationContext[length - 1].viewLabel;
		}

		protected get showBreadcrumbs(): boolean {
			return this.breadcrumbs.length > 1 && !this.hasEmptyLabel;
		}

		protected get showArrow(): boolean {
			const requiredLength = 2;

			return (
				this.breadcrumbs.length === requiredLength &&
				this.navigationItems[this.navigationItems.length - 1].viewId === aps.context._view.id
			);
		}

		protected handleBreadcrumbClick(idx: number): void {
			if (this.showArrow) {
				idx = 0;
			}
			const { viewId, resourceId, parameters, subscriptionId } = this.navigationItems[idx];

			if (viewId !== aps.context._view.id) {
				(aps.navigation.tree as APS.INavigationTree).context.splice(idx + 1);

				aps.apsc.gotoView(viewId, resourceId || '', parameters, subscriptionId || '');
			}
		}
	}
